import { render, staticRenderFns } from "./review_add.vue?vue&type=template&id=446ccfc4&scoped=true&"
import script from "./review_add.vue?vue&type=script&lang=js&"
export * from "./review_add.vue?vue&type=script&lang=js&"
import style0 from "./review_add.vue?vue&type=style&index=0&id=446ccfc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ccfc4",
  null
  
)

export default component.exports